/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-12-10 10:04:43                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-01-22 15:04:52                               *
 *****************************************************************************/


/* SUMMARY
  * Imports
  * Styles
  * MapMarker: map marker with custom icon
    * useEffect: set maker label
*/

/* Imports */
import { MapPinIcon, TruckIcon } from "@heroicons/react/24/solid";
import { Tooltip } from "@material-tailwind/react";
/***/

/* Styles */
import "./MapMarker.scss";
import AddressDisplay from "../data/address/AddressDisplay";
import { useEffect, useState } from "react";
import TechnicianDisplay from "../data/technician/TechnicianDisplay";
/***/

/**
* MapMarker: map marker with custom icon
* @param lat - latitude point
* @param lng - longitude point
* @param address - address object
* @param technician - technician informations
* @param icon - icon type
* @param onClick - on click event
*/
export default function MapMarker({
  lat,
  lng,
  address,
  technician,
  icon = "pin",
  unavailable,
  onClick
}: {
  lat: number,
  lng: number,
  address?: EasyTech.Address,
  technician?: EasyTech.Technician,
  icon?: "pin" | "truck",
  unavailable?: boolean,
  onClick?: () => void
}) {
  const [label, setLabel] = useState<JSX.Element>();

  /**
  * useEffect: set maker label 
  */
  useEffect(() => {
    if (address) setLabel(<AddressDisplay address={address} />);
    else if (technician) setLabel(<TechnicianDisplay technician={technician} />);
  }, [address, technician]);
  /***/

  return (
    <Tooltip content={label}>
      <div className="map-marker" onClick={() => onClick && onClick()}>
        {icon === "pin" && <MapPinIcon className="text-red-600" />}
        {icon === "truck" && <TruckIcon className={`${unavailable ? "text-red-600" : "text-light-blue-600"}`} />}
      </div>
    </Tooltip>
  );
}
/***/
